import * as React from "react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"

import { cn } from "#/lib/utils"
import { CheckIcon, MinusIcon } from "lucide-react"

function Checkbox({
  className,
  ...props
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "group peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-gray-400 bg-panel transition-colors outline-none after:absolute after:-inset-x-3 after:-inset-y-2 hover:border-primary-500 hover:ring-1 hover:ring-primary-500/35 focus-visible:border-primary-500 focus-visible:ring-1 focus-visible:ring-primary-500/35 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-red-500 aria-invalid:ring-1 aria-invalid:ring-red-500/35 data-checked:border-primary-500 data-checked:bg-primary-500 data-checked:text-white data-[state=indeterminate]:border-primary-500 data-[state=indeterminate]:bg-primary-500 data-[state=indeterminate]:text-white dark:bg-input/30",
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3.5">
        <CheckIcon className="hidden group-data-[state=checked]:block" />
        <MinusIcon className="hidden group-data-[state=indeterminate]:block" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox }
